import React from 'react';
import { Link } from 'react-router-dom';

import styles from './NotFound.module.scss';

function NotFound() {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>404</h1>
      <p className={styles.message}>К сожалению, страница не найдена.</p>
      <p className={styles.message}>Возможно, она была перемещена или удалена.</p>
      <Link to="/" className={styles.link}>
        Вернуться на главную
      </Link>
    </div>
  );
}

export default NotFound; 